import React from "react";
import TermsConditionsContent from "../components/Settings/TermsConditionsContent";

const TermsConditions = () => {
  return (
    <>
      <TermsConditionsContent />
    </>
  );
};

export default TermsConditions;
